import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { HardHat } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal, Label } from "@/components/site/Motion";

export default function WorkInProgress() {
  const { data: items = [] } = useQuery({
    queryKey: ["progress"],
    queryFn: async () => (await api.get("/progress")).data,
  });

  if (!items.length) return null;

  return (
    <section className="relative grain overflow-hidden bg-navy-deep text-white py-24 lg:py-32" data-testid="work-in-progress">
      <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex items-center gap-3">
          <HardHat className="h-6 w-6 text-gold" strokeWidth={1.4} />
          <Label>On site now</Label>
        </div>
        <h2 className="mt-5 font-display text-4xl md:text-5xl font-light tracking-tight mb-14">
          Work in progress
        </h2>

        <div className="space-y-10">
          {items.map((item, idx) => (
            <Reveal key={item.id} delay={(idx % 2) * 0.05}>
              <div className="grid gap-8 md:grid-cols-12 border-t border-white/12 pt-8">
                <div className="md:col-span-4">
                  {item.stage && (
                    <span className="inline-block rounded-full bg-gold/15 px-3 py-1 text-xs uppercase tracking-[0.15em] text-gold">
                      {item.stage}
                    </span>
                  )}
                  <h3 className="mt-4 font-display text-2xl md:text-3xl">{item.title}</h3>
                  {item.location && <p className="mt-2 text-white/50 text-sm">{item.location}</p>}
                  {item.description && <p className="mt-4 text-white/55 leading-relaxed text-sm">{item.description}</p>}
                </div>
                <div className="md:col-span-8">
                  <div className="flex gap-4 overflow-x-auto pb-2 snap-x">
                    {(item.images || []).map((img, i) => (
                      <motion.div
                        key={i}
                        whileHover={{ scale: 1.02 }}
                        className="relative h-56 w-80 shrink-0 snap-start overflow-hidden rounded-sm"
                      >
                        <img src={img} alt={`${item.title} stage ${i + 1}`} className="h-full w-full object-cover" />
                        <span className="absolute bottom-3 left-3 rounded-full bg-navy-deep/70 px-3 py-1 text-xs text-white">
                          Stage {i + 1}
                        </span>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
